<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputPassword" });
import { Input } from "../../../../inputs/index.js";
import Icon from "../../../../elements/icon/Icon.svelte";
export let value;
export let autocomplete = "new-password";
export let placeholder = "resource.user.properties.password.placeholder";
export let label = "resource.user.properties.password.label";
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
const MINLENGTH = 8;
let isPasswordMasked = true;
const togglePasswordMask = () => {
    isPasswordMasked = !isPasswordMasked;
};
</script>

<div class = 's8-input-password'>
    <Input
        bind:value
        hint = 'resource.user.properties.password.hint'
        minLength = { MINLENGTH }
        name = 'user.password'
        type = { isPasswordMasked ? 'password' : 'text' }
        { autocomplete }
        { isDisabled }
        { isReadonly }
        { isRequired }
        { placeholder }
        { label }
    >
        <svelte:fragment slot = 'afterInput'>
            <Icon
                key = { isPasswordMasked ? 'show' : 'hide' }
                on:click = { togglePasswordMask }
            />
        </svelte:fragment>
    </Input>
</div>

<style>
    div.s8-input-password :global(svg) {
            height: 18px;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
        }</style>